import { HoldingsSummary } from "./types";

export const taxWithheldOf = (
  summary: Pick<HoldingsSummary, "withholdingTaxCosts" | "interestTaxWithheld">,
): number | null =>
  summary.withholdingTaxCosts === null
    ? null
    : summary.withholdingTaxCosts + (summary.interestTaxWithheld ?? 0);
